// Lite, Plus and Pro are retired: new programs are custom only. Their programs docs stay,
// because current clients' prices, deliverables and saved proposals still read them, so they
// are only hidden from places that offer a program to pick.
export const RETIRED_STANDARD_PROGRAM_KEYS = ['Lite', 'Plus', 'Pro'];

export const isRetiredProgram = (key, program) =>
  RETIRED_STANDARD_PROGRAM_KEYS.includes(key) || program?.offerStatus === 'retired';
